import request from '../utils/axios/request';
import { PaginationContent } from '../utils/types/pagination';
import { Query } from '../utils/types/query';
import { IClient, QueryClient } from './Client.service';

export interface IShip {
	id?: number;
	name: string;
	owner: string;
	isActive: boolean;
	client?: Partial<IClient>;
	createdAt?: Date;
	updatedAt?: Date;
	actions?: any;
}

abstract class ShipService {
	static async getAll(
		params: QueryClient
	): Promise<PaginationContent<IShip> | undefined> {
		let isActive;
		if (params?.isActive && Number(params.isActive) > -1) {
			isActive = params.isActive;
		}

		try {
			const response: PaginationContent<IShip> = await request(
				'/ships',
				'get',
				{
					params: { ...params, isActive },
				}
			);
			return response;
		} catch (error: any) {}
	}

	static async create(
		data: IShip,
		setError: React.Dispatch<React.SetStateAction<string>>
	) {
		return this.createOrEdit(data, setError, 'post');
	}

	static async edit(
		data: IShip,
		setError: React.Dispatch<React.SetStateAction<string>>
	) {
		return this.createOrEdit(data, setError, 'patch');
	}

	private static async createOrEdit(
		content: IShip,
		setError: React.Dispatch<React.SetStateAction<string>>,
		mode: 'post' | 'patch'
	) {
		try {
			const { id, client, createdAt, updatedAt, ...data } = content;
			const url = mode === 'post' ? '/ships' : `/ships/${id}`;
			const response = await request(url, mode, {
				data: { ...data, idClient: client?.id },
			});
			return response;
		} catch (error) {
			setError('alert.error.generic');
		}
	}
}

export default ShipService;
